import {Component, React, observer} from '$src/handy'
import * as css from './Badge.css'

interface Props {
  color: string
  badgeContent: number
  visible: boolean
}

@observer
export default class Badge extends Component<Props, {}> {
  render() {
    const {props} = this
    const {children} = props

    return (
      <div className={css.container}>
        {children}
        {props.visible && (
          <span className={css.badge} style={{ backgroundColor: props.color }} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/Badge.tsx